import React from 'react'
import * as styles from "../styles/recents.module.css"
import { useBreakpoint } from 'gatsby-plugin-breakpoints';


export default function Recents() {
    const breakpoints = useBreakpoint();
    if (breakpoints.tablet) {
        return (
            <section className={styles.containerMobile}>
                <div>
                    <h1 className={styles.titleMobile}>Recent Results</h1>
                </div>
                <div className={styles.results}>
                    {/* <div className={styles.columnMobile}>
                        <center className={styles.gameTitleMobile}>
                            <h1>Valorant</h1>
                        </center>
                        <div className={styles.resultcardmobile}>
                            <div className={styles.logoMobile}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                            <center className={styles.scoreMobile}>2 - 5</center>
                            <div className={styles.logoMobile}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                        </div>

                        <div className={styles.resultcardmobile}>
                            <div className={styles.logoMobile}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                            <center className={styles.scoreMobile}>3 - 1</center>
                            <div className={styles.logoMobile}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                        </div>
                    </div> */}
                    <div className={styles.columnMobile}>
                        <center className={styles.gameTitleMobile}>
                            <h1>League of Legends</h1>
                        </center>
                        <div className={styles.resultcardmobile}>
                            <div className={styles.logoMobile2}>
                                <img src="images/team-logos/raad.png" alt="Raad Logo" className={styles.logoImage} />
                            </div>
                            <center className={styles.scoreMobile}>0 - 1</center>
                            <div className={styles.logoMobile}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                        </div>
                        <div className={styles.resultcardmobile}>
                            <div className={styles.logoMobile2}>
                                <img src="images/team-logos/gxr.png" alt="GXR Logo" className={styles.logoImage} />
                            </div>
                            <center className={styles.scoreMobile}>0 - 1</center>
                            <div className={styles.logoMobile}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                        </div>
                    </div>
                    <div className={styles.columnMobile}>
                        <center className={styles.gameTitleMobile}>
                            <h1>Wild Rift</h1>
                        </center>
                        <div className={styles.resultcardmobile}>
                            <div className={styles.logoMobile3}>
                                <img src="images/team-logos/cut.png" alt="CUT Logo" className={styles.logoCutImage} />
                            </div>
                            <center className={styles.scoreMobile}>3 - 2</center>
                            <div className={styles.logoMobile}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                        </div>

                        <div className={styles.resultcardmobile}>
                            <div className={styles.logoMobile2}>
                                <img src="images/team-logos/sunlight.png" alt="Sunlight Logo" className={styles.logoImage} />
                            </div>
                            <center className={styles.scoreMobile}>2 - 0</center>
                            <div className={styles.logoMobile}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                        </div>
                    </div>
                    {/* <div className={styles.columnMobile}>
                        <center className={styles.gameTitleMobile}>
                            <h1>PUBG Mobile</h1>
                        </center>
                        <div className={styles.resultcardmobile}>
                            <div className={styles.logoMobile}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                            <center className={styles.scoreMobile}>3 - 1</center>
                            <div className={styles.logoMobile}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                        </div>
                        <div className={styles.resultcardmobile}>
                            <div className={styles.logoMobile}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                            <center className={styles.scoreMobile}>3 - 1</center>
                            <div className={styles.logoMobile}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                        </div>
                    </div> */}

                </div>
            </section>
        )
    }
    else if (breakpoints.sm) {
        return (
            <section className={styles.containerSM}>
                <div>
                    <h1 className={styles.titleSM}>Recent Results</h1>
                </div>
                <div className={styles.results}>
                    <div className={styles.rowSM}>
                        <div className={styles.resultcardSM}>
                            <div className={styles.logoSM}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                            <center className={styles.scoreSM}>2 - 5</center>
                            <div className={styles.logoSM}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                        </div>
                        <center className={styles.gameTitleSM}>
                            <h1>Valorant</h1>
                        </center>
                        <div className={styles.resultcardSM}>
                            <div className={styles.logoSM}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                            <center className={styles.scoreSM}>3 - 1</center>
                            <div className={styles.logoSM}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                        </div>
                    </div>
                    <div className={styles.rowSM}>
                        <div className={styles.resultcardSM}>
                            <div className={styles.logoSM}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                            <center className={styles.scoreSM}>3 - 1</center>
                            <div className={styles.logoSM}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                        </div>
                        <center className={styles.gameTitleSM}>
                            <h1>League of Legends</h1>
                        </center>
                        <div className={styles.resultcardSM}>
                            <div className={styles.logoSM}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                            <center className={styles.scoreSM}>3 - 1</center>
                            <div className={styles.logoSM}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                        </div>
                    </div>
                    <div className={styles.rowSM}>
                        <div className={styles.resultcardSM}>
                            <div className={styles.logoSM}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                            <center className={styles.scoreSM}>2 - 5</center>
                            <div className={styles.logoSM}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                        </div>
                        <center className={styles.gameTitleSM}>
                            <h1>Wild Rift</h1>
                        </center>
                        <div className={styles.resultcardSM}>
                            <div className={styles.logoSM}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                            <center className={styles.scoreSM}>3 - 1</center>
                            <div className={styles.logoSM}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                        </div>
                    </div>
                    <div className={styles.rowSM}>
                        <div className={styles.resultcardSM}>
                            <div className={styles.logoSM}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                            <center className={styles.scoreSM}>3 - 1</center>
                            <div className={styles.logoSM}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                        </div>
                        <center className={styles.gameTitleSM}>
                            <h1>PUBG Mobile</h1>
                        </center>
                        <div className={styles.resultcardSM}>
                            <div className={styles.logoSM}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                            <center className={styles.scoreSM}>3 - 1</center>
                            <div className={styles.logoSM}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        )
    }
    else {
        return (
            <section className={styles.container}>
                <div>
                    <h1 className={styles.title}>Recent Results</h1>
                </div>
                <div className={styles.results}>
                    {/* <div className={styles.row}>
                        <div className={styles.resultcard}>
                            <div className={styles.logo}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                            <center className={styles.score}>2 - 5</center>
                            <div className={styles.logo}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                        </div>
                        <center className={styles.gameTitle}>
                            <h1>Valorant</h1>
                        </center>
                        <div className={styles.resultcard}>
                            <div className={styles.logo}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                            <center className={styles.score}>3 - 1</center>
                            <div className={styles.logo}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                        </div>
                    </div> */}
                    <div className={styles.row}>
                        <div className={styles.resultcard}>
                            <div className={styles.logo}>
                                <img src="images/team-logos/raad.png" alt="RAAD Logo" className={styles.logoImage} />
                            </div>
                            <center className={styles.score}>0 - 1</center>
                            <div className={styles.logo}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                        </div>
                        <center className={styles.gameTitle}>
                            <h1>League of Legends</h1>
                        </center>
                        <div className={styles.resultcard}>
                            <div className={styles.logo}>
                                <img src="images/team-logos/gxr.png" alt="GXR Logo" className={styles.logoImage} />
                            </div>
                            <center className={styles.score}>0 - 1</center>
                            <div className={styles.logo}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                        </div>
                    </div>
                    <div className={styles.row}>
                        <div className={styles.resultcard}>
                            <div className={styles.logoCut}>
                                <img src="images/team-logos/cut.png" alt="CUT Logo" className={styles.logoCutImage} />
                            </div>
                            <center className={styles.score}>3 - 2</center>
                            <div className={styles.logo}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                        </div>
                        <center className={styles.gameTitle}>
                            <h1>Wild Rift</h1>
                        </center>
                        <div className={styles.resultcard}>
                            <div className={styles.logo}>
                                <img src="images/team-logos/sunlight.png" alt="Sunlight Logo" className={styles.logoImage} />
                            </div>
                            <center className={styles.score}>2 - 0</center>
                            <div className={styles.logo}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                        </div>
                    </div>
                    {/* <div className={styles.row}>
                        <div className={styles.resultcard}>
                            <div className={styles.logo}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                            <center className={styles.score}>3 - 1</center>
                            <div className={styles.logo}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                        </div>
                        <center className={styles.gameTitle}>
                            <h1>PUBG Mobile</h1>
                        </center>
                        <div className={styles.resultcard}>
                            <div className={styles.logo}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                            <center className={styles.score}>3 - 1</center>
                            <div className={styles.logo}>
                                <img src="images/team-logos/geekay.png" alt="Geekay Logo" className={styles.logoImage} />
                            </div>
                        </div>
                    </div> */}

                </div>
            </section>
        )
    }
}
